var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHazmasdinero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "53px",
    viewBox: "0 0 76 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/$") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/$",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9378125,23.51875 C34.6378125,21.829375 31.1265625,21.166875 31.1265625,17.29125 C31.1265625,14.541875 33.5115625,11.925 38.0828125,11.925 C43.3496875,11.925 45.0390625,14.84 45.0390625,18.35125 L51.3328125,18.35125 C51.3328125,12.421875 47.4571875,8.115625 41.3953125,6.95625 L41.3953125,0 L34.7703125,0 L34.7703125,6.989375 C29.5365625,8.049375 24.8328125,11.5275 24.8328125,17.324375 C24.8328125,24.7775 30.7290625,26.599375 38.0828125,28.984375 C44.3103125,31.005 45.5359375,32.429375 45.5359375,35.9075 C45.5359375,38.88875 43.3165625,41.075 38.0828125,41.075 C34.1078125,41.075 30.6296875,38.2925 30.6296875,34.25125 L24.0046875,34.25125 C24.0046875,40.47875 28.5759375,44.85125 34.7703125,46.04375 L34.7703125,53 L41.3953125,53 L41.3953125,46.143125 C48.1528125,45.1825 51.9953125,41.2075 51.9953125,35.874375 C51.9953125,29.68 48.8815625,26.3675 39.9378125,23.51875 L39.9378125,23.51875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHazmasdinero);
export default __webpack_public_path__ + "static/media/icon_hazmasdinero.9d4e3c095f7254585ffd8912faf62603.svg";
export { ForwardRef as ReactComponent };